module.exports = __webpack_public_path__ + "static/media/main-logo-sp.40d963f9.png";